import { Box, CSSObject, Flex, Heading, Icon, Link, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContractQuery } from 'generated/graphql';
import { NavLink, useLocation } from 'react-router-dom';

type Document = NonNullable<ContractQuery['contract']['documents']['edges'][number]['node']>;
interface Props {
  document: Document;
}

const activeStyles: CSSObject = {
  bg: 'white',
  boxShadow: 'lg',
};

const getSubheading = (document: Document) => {
  if (document.status === 'completed') return 'Completed!';
  if (document.esign) return 'Please sign';
  return 'Please upload a file';
};

function DocumentListItem({ document }: Props) {
  const { search } = useLocation();

  const completed = document.status === 'completed';

  return (
    <Link
      as={NavLink}
      to={{ pathname: `documents/${document.id}`, search }}
      _hover={{ textDecoration: 'none' }}
      sx={{ '&.active > div': activeStyles }}
    >
      <Flex
        h="82"
        p={4}
        borderBottom="1px"
        borderColor="gray.200"
        align="center"
        sx={{ 'a:hover &': activeStyles }}
      >
        <Icon
          as={FontAwesomeIcon}
          icon={['fal', completed ? 'circle-check' : 'circle']}
          size="3x"
          color={completed ? 'green.400' : 'gray.700'}
        />
        <Box flex={1} px={3}>
          <Heading as="h5" size="sm" mb={1}>
            {document.name}
          </Heading>
          <Text>{getSubheading(document)}</Text>
        </Box>
      </Flex>
    </Link>
  );
}

export default DocumentListItem;
